const myNavy = "#354259";
const myLightNavy = "#3b4860";
const myMintGreen = "#C2DED1";
const myMintGreenC0Alpha = "#C2DED1c0";
const myMilkYellow = "#ECE5C7";
const myMilkYellowC0Alpha = "#ece5c7c0"; // deep
const myMilkYellow30Alpha = "#ece5c730"; // deeper
const myTextLightGrey = "#BABABA";
const myTextGrey = "#9A9A9A";
const myBrown = "#CDC2AE";

export {
  myNavy,
  myLightNavy,
  myMintGreen,
  myMintGreenC0Alpha,
  myMilkYellow,
  myMilkYellowC0Alpha,
  myMilkYellow30Alpha,
  myTextLightGrey,
  myTextGrey,
  myBrown,
};
